<template>
    <router-view></router-view>
</template>
<script>
export default {
    created() {
        this.$store.dispatch("fetchWidgets").catch(error => {
            if (error.response.status == 500) {
                this.$serverErrorModal(error)
                return
            }

            this.$bvModal.msgBoxOk(this.$t('failedFetchWidgets'))
        })
    }
}
</script>
